import script from "./BillNotify.vue?vue&type=script&lang=ts&setup=true"
export * from "./BillNotify.vue?vue&type=script&lang=ts&setup=true"

import "./BillNotify.vue?vue&type=style&index=0&id=78c6839c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78c6839c"]])

export default __exports__